function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoader = function SvgLoader(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.486 7.724c.004.092.014.183.014.276 0 3.584-2.916 6.5-6.5 6.5S1.5 11.584 1.5 8 4.416 1.5 8 1.5q.033.001.065.003L9.433.136A8 8 0 0 0 8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8q-.002-.835-.166-1.624z",
    style: {
      fill: "#fff"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoader);
export default ForwardRef;